export type ContratStatut = "brouillon" | "actif" | "expire" | "resilie" | "suspendu";

export interface Contrat {
  id: string;
  immeubleId: string;
  bienId: string;
  locataireId: string;
  dateDebut: string;
  dateFin: string;
  loyerMensuel: number;
  caution: number;
  avance: number;
  jourEcheance: number;
  conditionsParticulieres: string;
  document: string;
  statut: ContratStatut;
  createdAt: string;
}

export type ContratInput = Omit<Contrat, "id" | "createdAt">;

export const CONTRAT_STATUT_LABELS: Record<ContratStatut, string> = {
  brouillon: "Brouillon",
  actif: "Actif",
  expire: "Expiré",
  resilie: "Résilié",
  suspendu: "Suspendu",
};

export const CONTRAT_STATUT_TONES: Record<ContratStatut, "primary" | "accent" | "secondary" | "neutral" | "danger"> = {
  brouillon: "neutral",
  actif: "secondary",
  expire: "accent",
  resilie: "danger",
  suspendu: "accent",
};

export const CONTRAT_STATUT_OPTIONS = (Object.keys(CONTRAT_STATUT_LABELS) as ContratStatut[]).map((value) => ({
  value,
  label: CONTRAT_STATUT_LABELS[value],
}));

export function contratReference(id: string): string {
  return `CTR-${id.slice(-6).toUpperCase()}`;
}

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `contrats`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   immeuble_id uuid references immeubles(id) on delete cascade
 *   bien_id uuid references biens(id) on delete cascade
 *   locataire_id uuid references locataires(id) on delete cascade
 *   date_debut date, date_fin date
 *   loyer_mensuel numeric, caution numeric, avance numeric
 *   jour_echeance int, conditions_particulieres text
 *   document_url text, statut text default 'brouillon'
 *   created_at timestamptz default now()
 * Les liens immeuble_id / bien_id / locataire_id relient chaque contrat aux données existantes.
 */